import React, { useState } from 'react'
import { fetchExcel, fetchPDF } from '@/common/fetch'
import { useWizard } from '@/common/wizard/wizard'
import { useAppContext } from '@/context/app'
import { machineRankingQuery, WizardData } from './Model'

export function MachineRankingExports({ disabled = false, report = 'machinesranking' }: { disabled?: boolean; report?: 'machinesranking' | 'fleetutilization' }) {
  const { services, session, translates } = useAppContext()
  const { wizardData } = useWizard<WizardData>()
  const [busy, setBusy] = useState(false)
  const [failed, setFailed] = useState(false)
  const selectionEmpty = wizardData.selectMachines && !wizardData.selectedMachineIds?.length
  const download = async (format: 'pdf' | 'excel') => {
    setBusy(true)
    setFailed(false)
    try {
      await (format === 'pdf' ? fetchPDF : fetchExcel)({
        url: `/api/communal/my/reports/${report}/${format}?${machineRankingQuery(wizardData, session?.user.lang || 'en')}`,
        fileName: report === 'fleetutilization' ? (format === 'pdf' ? 'fleet-utilization-ranking.pdf' : 'fleet-utilization.xlsx') : (format === 'pdf' ? 'machinesranking.pdf' : 'machines-ranking.xlsx'),
        services
      })
    } catch {
      setFailed(true)
    } finally {
      setBusy(false)
    }
  }
  return <>
    {failed && <span role='alert'>{translates?.for('report.machinesranking.selection.export_error')}</span>}
    <button type='button' className='btn btn-next' disabled={disabled || busy || selectionEmpty} onClick={() => download('excel')}>{translates?.for('popup.export.excel_export')}</button>
    <button type='button' className='btn btn-next' disabled={disabled || busy || selectionEmpty} onClick={() => download('pdf')}>{translates?.for(`report.${report}.wizard.gen_pdf`)}</button>
  </>
}
